import { useEffect } from 'react';

import { useOptionalUser } from '@adsk/alloy-provider';

import { useLaunchDarklyData } from './LaunchDarklyProvider';

const ACCLaunchDarklyOptionalSubscriber = () => {
  const { data: optionalUser } = useOptionalUser();
  const { setUser } = useLaunchDarklyData();

  useEffect(() => {
    if (optionalUser) {
      setUser({
        analyticsId: optionalUser.analyticsId,
        email: optionalUser.email,
      });
    }
  }, [optionalUser, setUser]);

  return null;
};

export default ACCLaunchDarklyOptionalSubscriber;
